export default __webpack_public_path__ + "static/media/city_car_category.87753da1.png";